import ABCyaPhaser from "@abcya/abcya_phaser";
import { TintReturn } from "../../Tabs/TrayItemsClickedActions/TintReturn";
import { SetTreeTint } from "../../Tabs/TrayItemsClickedActions/TreeClickHandler";
import { FallOffTree } from "../TweensFile";
import FontKeys from "../../../FontKeys";

/**
 * 
 * @param {Phaser.Scene} Scene 
 * @param {*} fromTree 
 * @param {*} NextTree 
 */
export function onStartOverButtonClicked(Scene,fromTree = false,NextTree)
{
    let Delay = 0;
    let BackGroundRect = Scene.add.rectangle(Scene.mid.x,Scene.mid.y,1024,768,0x000000,.5).setDepth(Scene.DepthList.DrawBlock);
    let PopUpShadow = Scene.add.rectangle(692, Scene.mid.y+6, 441,189, 0x000000, 0.5).setDepth(Scene.DepthList.DrawBlock);
    let PopUp = Scene.add.rectangle(680, Scene.mid.y-6, 441,189, 0xf70d0d).setDepth(Scene.DepthList.DrawBlock);
    let PopUpTxt = ABCyaPhaser.Text.addText(PopUp.x, PopUp.y-36, 24, 0xffffff, FontKeys._ffulbotano, ABCyaPhaser.Localization.instance.getLocalizedString("start_over_popup.text"), Scene).setWordWrapWidth(PopUp.width-100).setDepth(Scene.DepthList.DrawBlock).setLineSpacing(-4);

    if(Scene.CleanUpHelp)
    {
        Scene.CleanUpHelp.destroy();
        Scene.CleanUpHelp = "";
    }

    let BtnY = PopUp.getBottomCenter().y - 31 - 24;//31 is half btn height, 36 is measured distance
    let YesBtnX = PopUp.x - 29 - 46;//35 is measured distance, 46 is half button width
    let NoBtnX = PopUp.x + 29 + 46;

    let YesBtn = Scene.addImage(YesBtnX,BtnY,"Btn_Yes").setDepth(Scene.DepthList.DrawBlock);
    let YesBtnTxt = ABCyaPhaser.Text.addText(YesBtn.x, YesBtn.y-5, 24, 0xffffff, FontKeys._ffulbotano, ABCyaPhaser.Localization.instance.getLocalizedString("start_over_popup.yes_button"), Scene).setDepth(Scene.DepthList.DrawBlock);
    let NoBtn = Scene.addImage(NoBtnX,BtnY,"Btn_Yes").setDepth(Scene.DepthList.DrawBlock);
    let NoBtnTxt = ABCyaPhaser.Text.addText(NoBtn.x, NoBtn.y-5, 24, 0xffffff, FontKeys._ffulbotano, ABCyaPhaser.Localization.instance.getLocalizedString("start_over_popup.no_button"), Scene).setDepth(Scene.DepthList.DrawBlock);

    YesBtn.setInteractive();
    NoBtn.setInteractive();
    BackGroundRect.setInteractive();

    YesBtn.once('pointerup',()=>{
        Scene.AudioChan.Chan5.play('click_in_game');
        Scene.BackLog = [];
        _removePopUp();
        _startFallOffTree();
        if(fromTree)
        {
            Scene.AudioChan.Chan3.play('select_tree');

            let OldTree = {PreviousFrameName: Scene.ActiveTree.frame.name,TintBG: TintReturn(Scene.ActiveTree.tintTopRight)};
            OldTree.TintStrk = TintReturn(Scene.ActiveTree.getData('Stroke').tintTopRight);
    
            Scene.ActiveTree.getData('Stroke').setFrame(NextTree.frame.name.replace("BG","Strk"));
            Scene.ActiveTree.setFrame(NextTree.frame.name);
            Scene.HitBoxTree.setFrame(NextTree.frame.name);
    
            if(NextTree.tintTopRight != Scene.ActiveTree.tintTopRight)
            {
                SetTreeTint(Scene,NextTree);
            }
            //console.log("Active and no match")
        }
    });

    NoBtn.once('pointerup',()=>{
        Scene.AudioChan.Chan5.play('click_in_game');
        _removePopUp();

    });

    function _removePopUp()
    {
        PopUpShadow.destroy();
        PopUp.destroy();
        PopUpTxt.destroy();
        YesBtn.destroy();
        YesBtnTxt.destroy();
        NoBtn.destroy();
        NoBtnTxt.destroy();
        BackGroundRect.destroy();
    }

    function _startFallOffTree()
    {
        Scene.AudioChan.Chan4.play('start_over');
        Scene.OnTreeGroup.getChildren().forEach(element => {
            if(element.getData('AssetType') === "Gfts")
            {
                FallOffTree(Scene,element,0);
            }
            else
            {
                if(element.length && element.type != "Container")
                {
                    element.forEach(inElement => {
                        FallOffTree(Scene,inElement,Delay);
                        Delay+=5;
                    });
                }
                else
                {
                    FallOffTree(Scene,element,Delay);
                    Delay+=5;
                }  
            }    
        });
    }
}